import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Select, Image } from "antd";
import { showConfirmDlgWidget } from 'components/ConfirmDlgWidget/showConfirmDlgWidget';
import "./TableWidget.css";

const { Option } = Select;

function TableWidget(props) {
    const [isBusy, setIsBusy] = useState(false);
    const { dataList, setDataList, onDeleteAction, onUpdateAction, onDuplicateAction } = props;

    function createMarkup(html) {
        return { __html: html };
    }

    if (dataList === undefined) return <div />

    const columns = [
        {
            title: "ID",
            dataIndex: "id",
        },
        {
            title: "Name",
            dataIndex: "name",
            align: "center",
            sorter: {
                compare: (a, b) => a.name.localeCompare(b.name),
            },
        },
        {
            title: "Avatar",
            dataIndex: "thumbnail_image",
            render: (text, record) => {
                if (record.avatar_image === null) {
                    return (
                        <img className="recipe-thumbnail-img" src={'/assets/icons/ic_picture.svg'} />
                    )
                }
                else {
                    return (
                        <Image
                            className="recipe-thumbnail-img"
                            src={record.thumbnail_image}
                        />
                        // <img className="recipe-thumbnail-img" src={record.thumbnail_image} />
                    )
                }

            },
        },
        {
            title: "Month",
            dataIndex: "month_date",
            align: "center",
            sorter: {
                compare: (a, b) => a.month_date.localeCompare(b.month_date),
            },
            render: (text, record) => {
                if (record.is_year_method === "0") {
                    return <div>{text}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>{text}</div>
                }
            }
        },
        {
            title: "Monthly Cost",
            dataIndex: "cost_per_month",
            align: "center",
            sorter: {
                compare: (a, b) => a.cost_per_month - b.cost_per_month,
            },
            render: (text, record) => {
                if (record.is_year_method === "0") {
                    return <div>$ {text}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>$ {text}</div>
                }
            }
        },
        {
            title: "Year",
            dataIndex: "year_date",
            align: "center",
            sorter: {
                compare: (a, b) => a.year_date.localeCompare(b.year_date),
            },
            render: (text, record) => {
                const year = new Date(text).getFullYear(); // This will safely extract the year
                if (record.is_year_method === "1") {
                    return <div>{year}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>{year}</div>
                }
            }

        },
        {
            title: "Year Cost",
            dataIndex: "cost_per_year",
            align: "center",
            sorter: {
                compare: (a, b) => a.cost_per_year - b.cost_per_year,
            },
            render: (text, record) => {
                if (record.is_year_method === "1") {
                    return <div>$ {text}</div>
                }
                else {
                    return <div style={{ textDecorationLine: 'line-through', color: 'lightgrey' }}>$ {text}</div>
                }
            }
        },
        {
            title: "Method",
            align: "center",
            dataIndex: "is_year_method",
            sorter: {
                compare: (a, b) => a.is_year_method - b.is_year_method,
            },
            render: (text, record) => {
                if (record.is_year_method === "1") {
                    return <span className="year-method">&nbsp;&nbsp;Year&nbsp;&nbsp;</span>
                }
                else {
                    return <span className="month-method">Month</span>
                }
            }
        },
        // {
        //     title: "Created Date",
        //     dataIndex: "add_timestamp",
        //     align: "center",
        //     sorter: {
        //         compare: (a, b) => a.add_timestamp.localeCompare(b.add_timestamp),
        //     },
        // },
        // {
        //     title: "Updated Date",
        //     dataIndex: "update_timestamp",
        //     align: "center",
        //     sorter: {
        //         compare: (a, b) => a.update_timestamp.localeCompare(b.update_timestamp),
        //     },
        // },
        {
            title: "Action",
            key: "action",
            align: "center",
            render: (text, record) => {
                return (
                    <div size="middle" direction={"vertical"}>
                        <a className="edit-btn"
                            onClick={() => {
                                onUpdateAction(record)
                            }}
                        >
                            Edit
                        </a>
                        <a style={{ color: "var(--orangeColor)", marginLeft: 20 }} className="del-btn" onClick={async () => {
                            onDuplicateAction(record)
                        }}>
                            Duplicate
                        </a>
                        <a style={{ color: "var(--redColor)", marginLeft: 20 }} className="del-btn" onClick={async () => {
                            var res = await showConfirmDlgWidget({ title: "Cacel Confirmation", content: "Are you sure to cancel this order?" });
                            if (res == false) return;
                            onDeleteAction(record)
                        }}>
                            Delete
                        </a>
                    </div>
                );
            },
        },
    ];
    const dataSource = dataList.map((info) => {
        return { ...info, key: info.id };
    });

    return (
        <div className="list-table">
            <Table
                size="small"
                pagination={{ defaultPageSize: 30, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50'] }}
                columns={columns}
                dataSource={dataSource}
            />
        </div>
    )
}

export default withRouter(TableWidget)
